<article class="task-browser__card task-browser__card--evidence">
    <div class="task-browser__heading">
        <div>
            <span class="task-browser__label">Evidence Requirement:</span>
            <p class="task-browser__assessment task-browser__heading-description">
                <span>{{ evidence.evidenceName }}</span>
            </p>
        </div>
        <div class="task-browser__heading-actions">
            <nz-tag class="task-browser__heading-status" [nzColor]="statusPresentation.tagColor">
                {{ statusPresentation.label }}
            </nz-tag>
            <div class="task-browser__heading-icon-actions">
                <button *ngIf="evidence.capabilities.canEmailEvidence" nz-button nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Send Email"
                    class="task-browser__icon-button task-browser__icon-button--email" type="button"
                    [attr.aria-label]="'Email evidence ' + evidence.evidenceName"
                    [disabled]="mutationPending" (click)="email.emit()"><i nz-icon nzType="mail" aria-hidden="true"></i></button>
                <button *ngIf="evidence.capabilities.canUpload" nz-button nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Upload Evidence"
                    class="task-browser__icon-button task-browser__icon-button--upload" type="button"
                    [attr.aria-label]="'Upload evidence ' + evidence.evidenceName"
                    [disabled]="mutationPending" (click)="upload.emit()"><i nz-icon nzType="upload" aria-hidden="true"></i></button>
                <button *ngIf="evidence.capabilities.canEditEvidence" nz-button nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Edit"
                    class="task-browser__icon-button task-browser__icon-button--edit" type="button"
                    [attr.aria-label]="'Edit evidence ' + evidence.evidenceName"
                    [disabled]="mutationPending" (click)="edit.emit()"><i nz-icon nzType="edit" aria-hidden="true"></i></button>
                <button *ngIf="evidence.capabilities.canDeleteEvidence" nz-button nzType="default" nzShape="circle" nzDanger nzSize="small" nz-tooltip nzTooltipTitle="Delete"
                    class="task-browser__icon-button task-browser__icon-button--delete" type="button"
                    [attr.aria-label]="'Delete evidence ' + evidence.evidenceName"
                    [disabled]="mutationPending" (click)="delete.emit()"><i nz-icon nzType="delete" aria-hidden="true"></i></button>
            </div>
        </div>
    </div>
    <p class="task-browser__assessment">
        <strong>Assessment:</strong>
        <a *ngIf="assessmentRoute as route; else unavailableEvidenceAssessmentTpl"
            [routerLink]="route" (click)="navigate.emit()">{{ evidence.assessmentLabel }}</a>
        <ng-template #unavailableEvidenceAssessmentTpl>{{ evidence.assessmentLabel }}</ng-template>
    </p>
    <div *ngIf="evidence.requirements.length" class="task-browser__requirements" role="group" aria-label="Applicable Controls">
        <span class="task-browser__label">Applicable Controls:</span>
        <span *ngFor="let requirement of evidence.requirements" class="task-browser__requirement">
            <a *ngIf="requirementLinks.get(requirementLinkKey(requirement)) as route; else unavailableEvidenceRequirementTpl"
                [routerLink]="route" (click)="navigate.emit()"
                [attr.aria-label]="'Open control ' + requirement.requirementKey">
                {{ requirement.requirementKey }}
            </a>
            <ng-template #unavailableEvidenceRequirementTpl>
                {{ requirement.requirementKey }}
            </ng-template>
        </span>
    </div>
    <div class="task-browser__details">
        <p><span class="task-browser__label">Last updated:</span> {{ formatDateTime(evidence.updatedAt) }}</p>
        <p *ngIf="evidence.dueDate"
            [class.task-browser__due--overdue]="evidenceDueState(evidence.dueDate, evidence.status) === 'overdue'"
            [class.text-danger]="evidenceDueState(evidence.dueDate, evidence.status) === 'overdue'"
            [class.task-browser__due--soon]="evidenceDueState(evidence.dueDate, evidence.status) === 'due_soon'"
            [class.text-warning]="evidenceDueState(evidence.dueDate, evidence.status) === 'due_soon'">
            <span class="task-browser__label task-browser__due-label">Due:&nbsp;</span><time [attr.datetime]="evidence.dueDate">{{ evidence.dueDate | date: 'd MMMM yyyy' }}</time>
        </p>
    </div>
    <div class="task-browser__assignees">
        <span class="task-browser__label">Assigned to:</span>
        <span *ngIf="!evidence.assignees.length">No current assignees</span>
        <span *ngFor="let assignee of evidence.assignees" class="task-browser__assignee">
            {{ assignee.displayName }}
            <small *ngIf="assignee.assignedAt">assigned {{ assignee.assignedAt | date: 'd MMM yyyy' }}
                <span *ngIf="assignee.assignedBy">by {{ assignee.assignedBy.displayName }}</span>
            </small>
        </span>
    </div>
    <div *ngIf="evidence.linkedSecureStorageFileId && evidence.linkedFileAccessible" class="task-browser__linked-file">
        <strong>Uploaded file:</strong> <span>{{ evidence.linkedFileName || 'Linked Secure Storage file' }}</span>
        <button nz-button nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Download linked file"
            type="button" aria-label="Download linked file" class="task-browser__icon-button" [disabled]="mutationPending"
            (click)="linkedFile.emit('download')"><i nz-icon nzType="download"></i></button>
        <button nz-button nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Preview linked file"
            type="button" aria-label="Preview linked file" class="task-browser__icon-button" [disabled]="mutationPending"
            (click)="linkedFile.emit('preview')"><i nz-icon nzType="eye"></i></button>
        <button nz-button nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Manage linked file"
            type="button" aria-label="Manage linked file" class="task-browser__icon-button" [disabled]="mutationPending"
            (click)="linkedFile.emit('manage')"><i nz-icon nzType="folder-open"></i></button>
    </div>
    <ng-content></ng-content>
</article>
